export default "__VITE_ASSET__70e231df__"